export default defineAppConfig({
  website: 'global',
  currentLanguage: 'it',
  currentLanguageCountry: 'it-it',
  currentAlgoliaIndex: `${process.env.ALGOLIA_PREFIX}index_it_it`,
  currentAlgoliaLookbookIndex: `${process.env.ALGOLIA_PREFIX}index_lookbook_it`,
  config: {
    country: 'it',
    languages: [
      {
        langcode: 'it',
        algolia_index: `${process.env.ALGOLIA_PREFIX}index_it_it`,
      },
      {
        langcode: 'en',
        algolia_index: `${process.env.ALGOLIA_PREFIX}index_it_en`,
      },
    ],
    is_shoppable: true,
    cl_market_code: 'IT',
  },
  currentMarketSettings: {
    region: '',
    max_MFCS: 2,
    max_cart: 10,
    isGiftMessageEnabled: true,
    isShoppingBagEnabled: true,
    isPaypalExpressEnabled: false,
  } as {
    region: string
    max_MFCS: number
    max_cart: number
    klarnaBNPLMaxPriceCents?: number
    paypalBNPLMaxPriceCents?: number
    klarnaPlacementKey?: string
    isGiftMessageEnabled?: boolean
    isShoppingBagEnabled?: boolean
    isPaypalExpressEnabled?: boolean
    marketId?: string
    paypalExpress?: { paymentMethodId: string; clientId?: string }
  },
})
